import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import posed, { PoseGroup } from 'react-pose';

import { Paper, Toolbar, Typography, IconButton } from '@material-ui/core';

import { withStyles } from '@material-ui/core/styles';
import classNames from 'classnames';

import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
  root: {
    background: '#fff',
    height: 'calc(100vh - 54px)',
    position: 'fixed',
    top: 54,
    zIndex: 1200,
    boxShadow: theme.shadows[12]
  },

  cover: {
    width: '100%',
    background: 'rgba(0,0,0, 0.5)',
    top: 54,
    left: '0px',
    height: 'calc(100vh - 54px)',
    zIndex: 1199,
    position: 'fixed',
    transform: 'all 300ms easi-in-out'
  },

  stackTitle: {
    float: 'left',
    width: 20,
    padding: '10px 15px',
    height: 'calc(100vh - 74px)',
    background: '#333',
    color: '#fff',
    '& span': {
      writingMode: 'tb-rl',
      transform: 'rotate(-180deg)'
    }
  },

  backButtonHolder: {
    marginRight: theme.spacing(2)
  },

  content: {
    overflow: 'auto'
  },

  heightWithHeader: {
    height: 'calc(100vh - 108px)'
  },

  heightWithoutHeader: {
    height: 'calc(100vh - 54px)'
  },

  right: {
    right: 0
  },

  left: {
    left: 0
  },

  large: {
    width: '80%',
    maxWidth: 1440,
    [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
      width: '80%',
      maxWidth: '90%'
    },
    [`@media (max-width: ${theme.breakpoints.values.sm}px)`]: {
      width: '100%',
      maxWidth: '100%'
    }
  },

  medium: {
    width: '50%',
    maxWidth: 600,
    [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
      width: '66%',
      maxWidth: '66%'
    },
    [`@media (max-width: ${theme.breakpoints.values.sm}px)`]: {
      width: '100%',
      maxWidth: '100%'
    }
  },

  small: {
    width: '33%',
    maxWidth: 450,
    [`@media (max-width: ${theme.breakpoints.values.md}px)`]: {
      width: '50%',
      maxWidth: '50%'
    },
    [`@media (max-width: ${theme.breakpoints.values.sm}px)`]: {
      width: '100%',
      maxWidth: '100%'
    }
  }
});

const StackContainer = posed.div({
  enter: {
    x: 0,
    delay: 0,
    transition: { ease: 'easeInOut' }
  },
  exit: {
    x: props => (props.direction === 'left' ? '-100%' : '100%'),
    transition: { duration: 300 }
  }
});

class Stack extends Component {
  render() {
    const { classes, children, show, title, onClose, size, direction, withHeader = true } = this.props;
    return (
      <Fragment>
        {show && <div onClick={onClose} className={classes.cover} />}
        <PoseGroup>
          {show && (
            <StackContainer
              id="stack"
              direction={direction}
              key="stack"
              className={classNames(classes.root, classes[direction || 'right'], classes[size])}
            >
              {/* <div className={classes.stackTitle}>
              {title && <span>{title}</span>}
            </div> */}
              {withHeader && (
                <Toolbar variant="dense" className={classes.sticky}>
                  <div className={classes.backButtonHolder}>
                    <IconButton color="secondary" onClick={onClose}>
                      <CloseIcon />
                    </IconButton>
                  </div>

                  <Typography variant="subtitle1" color="inherit" className={classes.flex}>
                    {title}
                  </Typography>
                </Toolbar>
              )}
              <Paper
                square
                className={[withHeader ? classes.heightWithHeader : classes.heightWithoutHeader, classes.content].join(
                  ' '
                )}
              >
                {children}
              </Paper>
            </StackContainer>
          )}
        </PoseGroup>
      </Fragment>
    );
  }
}

export default connect(() => ({}), {})(withStyles(styles)(Stack));
